import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
	root: {
		// borderRadius: 24,
		// maxHeight: 44,
		// paddingBottom: theme.spacing(1),
		// width: 'fit-content',
		width: '100%',

		'& .DateRangePickerInput': {
			...theme.typography.h6,
			display: 'flex',
			alignItems: 'center',
			width: 300,
		},
		'& .DateInput_input.DateInput_input_1': {
			display: 'flex',
			alignSelf: 'center',
			padding: '8px 2px 5px 2px',
			fontSize: '12px',
			fontWeight: '600',
			cursor: 'pointer',
			textAlign: 'center',
		},
		'& .CalendarMonth_caption': {
			paddingBottom: '39px',
		},
		'& .DateInput_input__focused': {
			borderBottom: '2px solid #15263E',
		},
		'& .DayPickerKeyboardShortcuts_show__bottomRight': {
			display: 'none',
		},
		'& .DateRangePickerInput.DateRangePickerInput_1.DateRangePickerInput__withBorder.DateRangePickerInput__withBorder_2':
			{
				margin: '0',
				borderRadius: '24px',
				paddingBottom: theme.spacing(0.25),
				border: '1px double rgba(0, 0, 0, 0.15)',
			},
		'& .DateRangePickerInput__withBorder': {
			border: 'none',
		},

		'& .CalendarDay__selected': {
			background: '#15263E',
			border: '1px double #15263E',
			'&:active': {
				background: '#15263E',
				border: '1px double #15263E',
			},
			'&:hover': {
				background: '#15263E',
				border: '1px double #15263E',
			},
		},
		'& .CalendarDay__selected_span': {
			background: 'rgba(2, 119, 189, 0.7)',
			border: '1px double #15263E',
			'&:active': {
				background: 'rgba(2, 119, 189, 0.7)',
				border: '1px double #15263E',
			},
			'&:hover': {
				background: 'rgba(2, 119, 189, 0.7)',
				border: '1px double #15263E',
			},
		},
		'& .CalendarDay__hovered_span': {
			border: '1px double #15263E',
			background: 'rgba(2, 119, 189, 0.7)',
			'&:hover': {
				background: '#15263E',
				border: '1px double #15263E',
				color: '#fff',
			},
		},
	},
}));
